import React, { useEffect } from "react";
import Alert from "react-bootstrap/Alert";
import PropTypes from "prop-types";
const Messages = ({ type, message, onClose }) => {
  useEffect(() => {
    setTimeout(() => {
      onClose();
    }, 6000);
  }, [onClose]);

  return (
    <Alert
      style={{
        margin: "10px 10px",
        padding: "12px 10px",
        height: "50px"
      }}
      key={type}
      variant={type}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <p>{message}</p>
        <span
          style={{ fontWeight: "bold", cursor: "pointer" }}
          onClick={onClose}>
          X
        </span>
      </div>
    </Alert>
  );
};

Messages.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default Messages;
